module.exports = __webpack_public_path__ + "static/media/WarriorGirlBookCover.7a4bf5c5.jpg";